import styled, { css } from 'styled-components'

export const StyledWrapper = styled.div`
    position: relative;
`

export const StyledCarouselControl = styled.div`
    position: absolute;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
    ${({side}) =>  side === 'left' ? css`left: -5%;` : css`right: -5%;`}

    img {
        cursor: pointer;
        ${({side}) =>  side === 'left' ? css`transform: rotate(180deg);` : css``};
    }

    @media screen and (max-width: 576px) {
        ${({side}) =>  side === 'left' ? css`left: 0;` : css`right: 0;`}
        top: 110%;
    }
`

export const StypedPano = styled.div`
    height: 500px;
    width: 100%;
    @media screen and (max-width: 576px) {
        height: 200px;
    }
`